import { useEffect } from 'react';
import useAuth from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { GuardProps } from 'types/auth';

const GuestGuard = ({ children }: GuardProps) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      // Uncomment and update APP_DEFAULT_PATH if navigation is needed
      // navigate(APP_DEFAULT_PATH, { replace: true }); // NOSONAR
    }
  }, [isLoggedIn, navigate]);

  return children;
};

export default GuestGuard;
